import React from 'react';
import cn from 'classnames';
import Card, { CardHeader } from '../../../../components/Card';
import styles from './InfoBlock.module.scss';

const InfoBlock = ({
  className,
  titleClassName,
  dark = true,
  title,
  action,
  children,
}) => {
  return (
    <Card dark={dark} className={cn(styles.root, className)}>
      {(title || action) && (
        <CardHeader
          title={title}
          titleProps={{ className: cn(styles.title, titleClassName) }}
          action={action}
        />
      )}
      {children}
    </Card>
  );
};

export default InfoBlock;
